import { render, staticRenderFns } from "./personalinformation.vue?vue&type=template&id=993428ba&scoped=true"
import script from "./personalinformation.vue?vue&type=script&lang=js"
export * from "./personalinformation.vue?vue&type=script&lang=js"
import style0 from "./personalinformation.vue?vue&type=style&index=0&id=993428ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993428ba",
  null
  
)

export default component.exports